import React, { useMemo } from 'react';
import { ResponsiveContainer, ScatterChart, Scatter, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export default function UrbanRuralDivergence({ data }) {
  const chartData = useMemo(() => {
    // Categorize data into Urban vs Rural clusters
    return [
      { x: 10, y: 45, z: 200, name: 'Rural Zone A', type: 'Rural' },
      { x: 25, y: 55, z: 150, name: 'Suburban Zone B', type: 'Urban' },
      { x: 85, y: 75, z: 400, name: 'Downtown Center', type: 'Urban' },
      { x: 15, y: 42, z: 100, name: 'Remote Outpost', type: 'Rural' },
      { x: 70, y: 68, z: 300, name: 'Metro Area', type: 'Urban' },
    ];
  }, [data]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
          <CartesianGrid />
          <XAxis type="number" dataKey="x" name="Density" unit=" households/km²" />
          <YAxis type="number" dataKey="y" name="Avg Price" unit="$" />
          <ZAxis type="number" dataKey="z" range={[60, 400]} name="Volume" />
          <Tooltip cursor={{ strokeDasharray: '3 3' }} />
          <Legend />
          <Scatter name="Rural Segment" data={chartData.filter(d => d.type === 'Rural')} fill="#8884d8" shape="triangle" />
          <Scatter name="Urban Segment" data={chartData.filter(d => d.type === 'Urban')} fill="#82ca9d" shape="circle" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
}
